/**
 * NotFoundPage — 404 page in the site's page layout, with links to the most useful pages.
 */

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumbs from '../Components/Breadcrumbs';
import Footer from '../Components/Footer';
import './NotFoundPage.css';

const POPULAR = [
  { to: '/calculator', label: 'Lye calculator', desc: 'Cold and hot process, NaOH and KOH' },
  { to: '/melt-and-pour', label: 'Melt & pour calculator', desc: 'Weigh out base, fragrance and colour' },
  { to: '/recipes', label: 'My recipes', desc: 'Your saved soap recipes' },
  { to: '/blog', label: 'Guides', desc: 'Safety, troubleshooting and selling' },
  { to: '/community', label: 'Community', desc: 'Ask other soap makers' },
  { to: '/contact', label: 'Contact us', desc: 'We usually reply within a day' },
];

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="sl-page">
      <div className="pageheader borderleft">
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Page not found' }]} />
        <div className="pageheader-row">
          <div className="pageheading">Page not found</div>
        </div>
      </div>

      <div className="borderleft">
        <section className="sl-band">
          <p className="sl-tagline">
            This page slipped away like a wet bar of soap. It may have moved, or the link may be mistyped.
          </p>
          <div className="sl-actions">
            <Link to="/" className="sl-btn sl-btn-primary">Go to the homepage</Link>
            <button className="sl-arrow-link nf-back" onClick={() => navigate(-1)}>Go back</button>
          </div>
        </section>

        <section className="sl-band">
          <h2 className="sl-subtitle">Popular pages</h2>
          <div className="sl-rule-grid">
            {POPULAR.map(link => (
              <Link key={link.to} to={link.to} className="sl-rule-cell">
                <h3>{link.label}</h3>
                <p>{link.desc}</p>
              </Link>
            ))}
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}
